// @flow
import * as React from 'react';
import type {
  FileComponents,
  Toggles,
  Reader,
  Platform,
} from 'docs/data/integration-builder';

const getFilename = (file: React.Element<any>): string => {
  return file.props.children.props.filename || '';
};

type FileConditions = $Shape<{
  toggles: Toggles,
  reader: ?Reader,
  platform: ?Platform,
}>;

const isVisible = (
  file: React.Element<any>,
  fileConditions: FileConditions,
): boolean => {
  const {when} = file.props.children.props;
  const {toggles, reader, platform} = fileConditions;
  if (when && when.toggle) {
    return toggles[when.toggle];
  }

  var conditions = [];

  if (reader && when && when.reader) {
    conditions.push(reader === when.reader);
  }

  if (platform && when && when.platform) {
    if (Array.isArray(when.platform)) {
      conditions.push(when.platform.includes(platform));
    } else {
      conditions.push(platform === when.platform);
    }
  }

  if (conditions.some((e) => e === false)) {
    return false;
  }

  return true;
};

export const loadFiles = (
  paths: Array<string>,
  fileConditions: FileConditions,
  children: Array<React.Element<any>>,
): FileComponents => {
  const components = {};
  children.forEach((child) => {
    if (
      paths.some((p) => child?.props?.file?.includes(`files/${p}`)) &&
      isVisible(child, fileConditions)
    ) {
      const filename = getFilename(child);
      components[filename] = child;
    }
  });
  return components;
};
